exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.diy-setpages-cover>img{\n  width: 60px;\n  height: 60px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/page/page/diy/params/Setpages.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd","file":"Setpages.vue","sourcesContent":["\n.diy-setpages-cover>img{\n  width: 60px;\n  height: 60px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78e92a7e","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/page/page/diy/params/Setpages.vue
// module id = qbw4
// module chunks = 0